import React, { Component } from "react";
import NumberFormat from "react-number-format";

class SearchOrderCustomer extends Component {
	render() {
		return (
			<div>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Order #</th>
								<th>Created</th>
								<th>Total</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr className="clickable" key={i} onClick={() => this.props.history.push(this.props.basePath + "/" + item.id)}>
									<td className="record-number">{i + this.props.startPosition + 1}</td>
									<td data-id="Order #">{item.invoiceid}</td>
									<td data-id="Date">{item.timestamp}</td>
									<td data-id="Total">
										<NumberFormat value={item.total_charged} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
									</td>
									<td className="edit-cell">
										<div className="edit_btn">View</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</div>
		);
	}
}

SearchOrderCustomer.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default SearchOrderCustomer;



// WEBPACK FOOTER //
// ./src/components/search/SearchOrderCustomer.js